export const ADD_TO_CART_SUCCESS= 'addToCartSuccess'
export const ADD_TO_CART_ERROR= 'addToCartFail'
export const REMOVE_FROM_CART= 'removeFromCart'
export const CART_RESET= 'resetCart'